export default __webpack_public_path__ + "static/media/Knockout-69.339032cb.otf";